"use client";

import { Route } from "@faire/web-api/Route";
import { props as privacyRouteProps } from "@faire/web-api/routes/privacy";
import React from "react";

import { PrivacyRouter } from "@faire/retailer/views/privacy/PrivacyRouter";

export const RenderPrivacyRoutes = () => {
  return <Route {...privacyRouteProps} component={PrivacyRouter} />;
};
